import { useEffect, useState } from "react";
import { Sparkles, CalendarClock, ShoppingCart, Users } from "lucide-react";

const fmt = (d) => new Date(`${d}T00:00:00`).toLocaleDateString(undefined, { day: "numeric", month: "long", year: "numeric" });

export function Ribbon({ r, slug }) {
  if (!r) return null;
  const soon = r.status === "coming_soon";
  return (
    <div className="absolute top-3 left-0 z-10 px-3 py-1 text-[11px] font-display font-bold tracking-[0.18em] text-[#1c1206] rounded-r-md bg-[#E9B949] border-y border-r border-[#F6D88A] shadow-[0_2px_10px_rgba(0,0,0,0.55)]" data-testid={`release-ribbon-${slug}`}>
      {soon ? "COMING SOON" : "NEW RELEASE"}
    </div>
  );
}

function useCountdown(date) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(t); }, []);
  const ms = Math.max(0, new Date(`${date}T00:00:00`).getTime() - now);
  return { d: Math.floor(ms / 864e5), h: Math.floor((ms / 36e5) % 24), m: Math.floor((ms / 6e4) % 60), s: Math.floor((ms / 1e3) % 60) };
}

function Countdown({ date, onDone }) {
  const c = useCountdown(date);
  const done = !c.d && !c.h && !c.m && !c.s;
  useEffect(() => { if (done) onDone(); }, [done]); // eslint-disable-line
  return (
    <div className="flex gap-2" data-testid="release-countdown">
      {[["d", "days"], ["h", "hrs"], ["m", "min"], ["s", "sec"]].map(([k, l]) => (
        <div key={k} className="w-14 text-center rounded-md border border-amber-500/40 bg-black/40 py-1.5"><p className="font-mono text-lg text-white">{String(c[k]).padStart(2, "0")}</p><p className="text-[9px] uppercase tracking-widest text-amber-300/80">{l}</p></div>
      ))}
    </div>
  );
}

export function ReleaseBanner({ r }) {
  const [live, setLive] = useState(false);
  if (!r) return null;
  const soon = r.status === "coming_soon" && !live;
  return (
    <div className="relative overflow-hidden rounded-xl border border-amber-400/50 bg-gradient-to-r from-amber-900/70 via-slate-950/80 to-amber-900/50 p-5 shadow-[0_0_40px_rgba(157,78,221,0.45)]" data-testid="release-banner">
      <div className="smoke" />
      <div className="relative flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          {soon ? <CalendarClock className="text-amber-300" size={24} /> : <Sparkles className="text-amber-300" size={24} />}
          <div><p className="font-display text-2xl font-bold tracking-wider text-white drop-shadow-[0_0_12px_rgba(199,125,255,0.9)]" data-testid="release-banner-label">{soon ? "Coming Soon" : "New Release"}</p>
            <p className="text-sm text-amber-100/90" data-testid="release-banner-date">{soon ? `Releases ${fmt(r.date)}` : `Out now · released ${fmt(r.date)}`}</p>
            {soon && r.readers_waiting && <p className="inline-flex items-center gap-1.5 mt-2 text-xs text-white bg-black/40 border border-amber-400/50 rounded-full px-2.5 py-0.5 shadow-[0_0_14px_rgba(199,125,255,0.5)]" data-testid="readers-waiting-badge"><Users size={12} className="text-amber-300" />{r.readers_waiting.toLocaleString()} readers waiting</p>}</div>
        </div>
        {soon && <Countdown date={r.date} onDone={() => setLive(true)} />}
        {r.link && <a href={r.link} target="_blank" rel="noopener noreferrer nofollow" className="glow-btn inline-flex items-center gap-2 bg-amber-600 hover:bg-amber-500 text-white px-5 py-2.5 rounded-lg font-medium border border-amber-300/40" data-testid="release-cta">
          <ShoppingCart size={15} />{soon ? "Pre-order on Amazon" : "Buy on Amazon"}</a>}
      </div>
    </div>
  );
}
